import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import InboundCall from "@/pages/Dashboard/InboundCall.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";

// Pages
import User from "@/pages/Dashboard/Pages/UserProfile.vue";
import Pricing from "@/pages/Dashboard/Pages/Pricing.vue";
import TimeLine from "@/pages/Dashboard/Pages/TimeLinePage.vue";
import RtlSupport from "@/pages/Dashboard/Pages/RtlSupport.vue";
import Login from "@/pages/Login.vue";
import Register from "@/pages/Dashboard/Pages/Register.vue";
import Lock from "@/pages/Dashboard/Pages/Lock.vue";

// Components pages
import Buttons from "@/pages/Dashboard/Components/Buttons.vue";
import GridSystem from "@/pages/Dashboard/Components/GridSystem.vue";
import Panels from "@/pages/Dashboard/Components/Panels.vue";
import SweetAlert from "@/pages/Dashboard/Components/SweetAlert.vue";
import Notifications from "@/pages/Dashboard/Components/Notifications.vue";
import NotificationsTest from "@/pages/Dashboard/Components/NotificationsTest.vue";
import Icons from "@/pages/Dashboard/Components/Icons.vue";

// Forms pages
import RegularForms from "@/pages/Dashboard/Forms/RegularForms.vue";
import ExtendedForms from "@/pages/Dashboard/Forms/ExtendedForms.vue";
import ValidationForms from "@/pages/Dashboard/Forms/ValidationForms.vue";
import Wizard from "@/pages/Dashboard/Forms/Wizard.vue";

// TableList pages
import RegularTables from "@/pages/Dashboard/Tables/RegularTables.vue";
import ExtendedTables from "@/pages/Dashboard/Tables/ExtendedTables.vue";
import PaginatedTables from "@/pages/Dashboard/Tables/PaginatedTables.vue";

// Maps pages
import GoogleMaps from "@/pages/Dashboard/Maps/GoogleMaps.vue";
import FullScreenMap from "@/pages/Dashboard/Maps/FullScreenMap.vue";
import VectorMaps from "@/pages/Dashboard/Maps/VectorMaps.vue";

// Calendar
import Calendar from "@/pages/Dashboard/Calendar.vue";

// Charts
import Charts from "@/pages/Dashboard/Charts.vue";
import Widgets from "@/pages/Dashboard/Widgets.vue";

import session from "@/kuaa/kuaa-sessions";

// =========================================================================

// added by psk 20200702 - 로그인 관련
import store from "../vuex/store";

// added by psk 20200702
const requireAuth = () => (to, from, next) => {
  let token = session.get('token');
  if(!token || token ==''){
    next("/login");
  }else{
    next();
  }
  //isAuth === true 면 페이지 이동

  // if (store.getters.getIsAuth) return next();
  // else next("/login"); // isAuth === false면 다시 로그인 화면으로 이동
  

  // next(); // 이거 나중에 지워야 함
};

// --------------------------- 교우/임원단 관리 -------------------------------

import GetMemberList from "@/pages/Friendship/GetMemberList"; // 교우 조회
import UpdateMember from "@/pages/Friendship/UpdateMember"; // 교우 관리
import UpdateExecutiveBoard from "@/pages/Friendship/UpdateExecutiveBoard"; // 임원단 관리
import UpdateStaff from "@/pages/Friendship/UpdateStaff"; // 교원 관리
import UpdatePostalMatter from "@/pages/Friendship/UpdatePostalMatter"; // 우편물 반송처리
import BundleUpdateMember from "@/pages/Friendship/BundleUpdateMember"; // 교우 일괄처리
import BundleUpdateNewMember from "@/pages/Friendship/BundleUpdateNewMember"; // 신규교우 일괄처리
import UpdateGraduationYear from "@/pages/Friendship/UpdateGraduationYear"; // 졸업회수 관리
import ExecutiveDirectorManagement from "@/pages/Friendship/ExecutiveDirectorManagement";
// import UpdateMemberAlt from "@/pages/Dashboard/Friendship/UpdateMemberAlt"; //

let FriendshipMenu = {
  path: "/Friendship",
  component: DashboardLayout,
  beforeEnter: requireAuth(), // 로그인 여부에 따라서...
  name: "교우/임원단 관리",
  redirect: "/Friendship/GetMemberList",
  children: [
    {
      path: "GetMemberList",
      name: "교우 조회",
      components: { default: GetMemberList }
    },
    {
      path: "UpdateMember",
      name: "교우 관리",
      components: { default: UpdateMember }
    },
    {
      path: "UpdateMember/:memberNo",
      component: UpdateMember,
      name: "교우 관리 상세",
      props: true
    },
    {
      path: "UpdateExecutiveBoard",
      name: "임원단 관리",
      components: { default: UpdateExecutiveBoard }
    },
    {
      path: "UpdateStaff",
      name: "교원 관리",
      components: { default: UpdateStaff }
    },
    {
      path: "UpdatePostalMatter",
      name: "우편물 반송처리",
      components: { default: UpdatePostalMatter }
    },
    {
      path: "BundleUpdateMember",
      name: "교우 일괄처리",
      components: { default: BundleUpdateMember }
    },
    {
      path: "BundleUpdateNewMember",
      name: "신규교우 일괄처리",
      components: { default: BundleUpdateNewMember }
    },
    {
      path: "UpdateGraduationYear",
      name: "졸업회수 관리",
      components: { default: UpdateGraduationYear }
    },
    {
      path: "ExecutiveDirectorManagement",
      name: "역대 회장단 관리",
      components: { default: ExecutiveDirectorManagement }
    }
  ]
};

// -------------------------- 회비 관리 --------------------------------

import SeveralManagement from "@/pages/MembershipFee/SeveralManagement";
import BundleManagement from "@/pages/MembershipFee/BundleManagement";
import GroupManagement from "@/pages/MembershipFee/GroupManagement";
import PaymentList from "@/pages/MembershipFee/PaymentList";
import PaymenStatistics from "@/pages/MembershipFee/PaymenStatistics";
import UpdateOCR from "@/pages/MembershipFee/UpdateOCR";
import PaymentCollection from "@/pages/MembershipFee/PaymentCollection";

let MembershipFeeMenu = {
  path: "/MembershipFee",
  component: DashboardLayout,
  beforeEnter: requireAuth(), // 로그인 여부에 따라서...
  name: "회비 관리",
  redirect: "/MembershipFee/SeveralManagement",
  children: [
    {
      path: "SeveralManagement",
      name: "회비 개별처리",
      components: { default: SeveralManagement }
    },
    {
      path: "SeveralManagement/:memberNo",
      component: SeveralManagement,
      name: "회비 개별처리 상세",
      props: true
    },
    {
      path: "BundleManagement",
      name: "회비 일괄처리",
      components: { default: BundleManagement }
    },
    {
      path: "GroupManagement",
      name: "단체회비 처리",
      components: { default: GroupManagement }
    },
    {
      path: "GroupManagement/:branchId/:branchNm/:branchGb",
      component: GroupManagement,
      name: "단체회비 처리 상세",
      props: true
    },
    {
      path: "PaymentList",
      name: "회비 납부내역",
      components: { default: PaymentList }
    },
    {
      path: "PaymenStatistics",
      name: "회비 통계",
      components: { default: PaymenStatistics }
    },
    {
      path: "UpdateOCR",
      name: "수납명세서(OCR)파일처리",
      components: { default: UpdateOCR }
    },
    {
      path: "PaymentCollection",
      name: "납부회수 등급 관리",
      components: { default: PaymentCollection }
    }
  ]
};

// -------------------------- 단체 관리 --------------------------------

import GroupList from "@/pages/MembershipGroup/GroupList";
import GroupMemberManagement from "@/pages/MembershipGroup/GroupMemberManagement";
import GroupMemberList from "@/pages/MembershipGroup/GroupMemberList";
import GroupExecutiveBoardList from "@/pages/MembershipGroup/GroupExecutiveBoardList";
import BusinessGroup from "@/pages/MembershipGroup/BusinessGroup";

let MembershipGroupMenu = {
  path: "/MembershipGroup",
  component: DashboardLayout,
  beforeEnter: requireAuth(), // 로그인 여부에 따라서...
  name: "단체 관리",
  redirect: "/MembershipGroup/GroupList",
  children: [
    {
      path: "GroupList",
      name: "단체 목록",
      components: { default: GroupList }
    },
    {
      path: "GroupMemberManagement",
      name: "단체 회원 관리",
      components: { default: GroupMemberManagement }
    },
    {
      path: "GroupMemberList",
      name: "단체 회원 조회",
      components: { default: GroupMemberList }
    },
    {
      path: "GroupExecutiveBoardList",
      name: "단체 임원진 조회",
      components: { default: GroupExecutiveBoardList }
    },
    {
      path: "BusinessGroup",
      name: "업무용 소모임 관리",
      components: { default: BusinessGroup }
    }
  ]
};

// -------------------------- 행사 관리 --------------------------------

import EventManagement from "@/pages/KuaaEvent/EventManagement";
import JoinMemberManagement from "@/pages/KuaaEvent/JoinMemberManagement";
import FamilyEventManagement from "@/pages/KuaaEvent/FamilyEventManagement";
import EventReplyManagement from "@/pages/KuaaEvent/EventReplyManagement";
import InfoReplyManagement from "@/pages/KuaaEvent/InfoReplyManagement";

let KuaaEventMenu = {
  path: "/KuaaEvent",
  component: DashboardLayout,
  beforeEnter: requireAuth(), // 로그인 여부에 따라서...
  name: "행사 관리",
  redirect: "/KuaaEvent/JoinMemberManagement",
  children: [
    {
      path: "EventManagement",
      name: "행사 관리 ",
      components: { default: EventManagement }
    },
    {
      path: "JoinMemberManagement",
      name: "행사 참여자 관리",
      components: { default: JoinMemberManagement }
    },
    {
      path: "FamilyEventManagement",
      name: "경조사 관리",
      components: { default: FamilyEventManagement }
    },
    {
      path: "EventReplyManagement",
      name: "행사참여 응답 관리",
      components: { default: EventReplyManagement }
    },
    {
      path: "InfoReplyManagement",
      name: "정보수정 응답 관리",
      components: { default: InfoReplyManagement }
    }
  ]
};

// -------------------------- 상담 관리 --------------------------------

import CounselorMain from "@/pages/Counselor/CounselorMain";
import CounselorCallBack from "@/pages/Counselor/CounselorCallBack";
import CounselorCampaign from "@/pages/Counselor/CounselorCampaign";
import CreateCampaign from "@/pages/Counselor/CreateCampaign";
import CampaignDistribution from "@/pages/Counselor/CampaignDistribution";
import CampaignResultList from "@/pages/Counselor/CampaignResultList";
// import CallbackDistribution from "@/pages/Dashboard/Counselor/CallbackDistribution";
import CallbackHistory from "@/pages/Counselor/CallbackHistory";

let CounselorMenu = {
  path: "/Counselor",
  component: DashboardLayout,
  beforeEnter: requireAuth(), // 로그인 여부에 따라서...
  name: "상담 관리",
  redirect: "/Counselor/CounselorCallBack",
  children: [
    {
      path: "CounselorCallBack",
      name: "상담사 콜백리스트",
      components: { default: CounselorCallBack }
    },
    {
      path: "CounselorCampaign",
      name: "상담사 캠페인",
      components: { default: CounselorCampaign }
    },
    {
      path: "CreateCampaign",
      name: "캠페인 생성관리",
      components: { default: CreateCampaign }
    },
    {
      path: "CampaignDistribution",
      name: "캠페인 분배",
      components: { default: CampaignDistribution }
    },
    {
      path: "CampaignResultList",
      name: "캠페인 결과조회",
      components: { default: CampaignResultList }
    },
    /*{
      path: "CallbackDistribution",
      name: "Call-Back 분배",
      components: { default: CallbackDistribution }
    }*/
    {
      path: "CallbackHistory",
      name: "콜백 이력 조회",
      components: { default: CallbackHistory }
    },
    {
      path: "CounselorMain",
      name: "상담사 메인",
      components: { default: CounselorMain }
    }
  ]
};

// -------------------------- 장학 관리 --------------------------------

import ApplicantList from "@/pages/Scholarship/ApplicantList";
import ApplicationForm from "@/pages/Scholarship/ApplicationForm";
import RecommendManagement from "@/pages/Scholarship/RecommendManagement";
import DonatorManagement from "@/pages/Scholarship/DonatorManagement";
import TuitionManagement from "@/pages/Scholarship/TuitionManagement";
import ScholarshipManagement from "@/pages/Scholarship/ScholarshipManagement";
import CertificateScholarship from "@/pages/Scholarship/CertificateScholarship";
import ScholarshipMappingList from "@/pages/Scholarship/ScholarshipMappingList";
import ScholarshipStatistics from "@/pages/Scholarship/ScholarshipStatistics";
import ScholarshipDashboard from "@/pages/Scholarship/ScholarshipDashboard";
import ScholarshipDashboard_old from "@/pages/Scholarship/ScholarshipDashboard_old";

let ScholarshipMenu = {
  path: "/Scholarship",
  component: DashboardLayout,
  beforeEnter: requireAuth(), // 로그인 여부에 따라서...
  name: "장학 관리",
  redirect: "/Scholarship/TermManagement",
  children: [
    {
      path: "ApplicantList",
      name: "신청자 조회",
      components: { 
        default: ApplicantList
      }
    },
    {
      path: "ApplicationForm",
      name: "신청서 등록",

      components: { default: ApplicationForm }
    },
    {
      path: "CertificateScholarship",
      name: "장학증서 수여식 관리",
      components: { default: CertificateScholarship }
    },
    {
      path: "RecommendManagement",
      name: "교우회(장학) 관리",
      components: { default: RecommendManagement }
    },
    {
      path: "DonatorManagement",
      name: "기부자 관리",
      components: { default: DonatorManagement }
    },
    {
      path: "TuitionManagement",
      name: "등록금 금액 관리",
      components: { default: TuitionManagement }
    },
    {
      path: "ScholarshipManagement",
      name: "장학신청 관리",
      components: { default: ScholarshipManagement }
    },
    {
      path: "ScholarshipMappingList",
      name: "장학매칭 관리",
      components: { default: ScholarshipMappingList }
    },
    {
      path: "ScholarshipStatistics",
      name: "장학 통계",
      components: { default: ScholarshipStatistics }
    },
    {
      path: "ScholarshipDashboard",
      name: "장학 대시보드",
      components: { default: ScholarshipDashboard }
    },
    {
      path: "ScholarshipDashboard_old",
      name: "장학 old 대시보드",
      components: { default: ScholarshipDashboard }
    }
  ]
};

// -------------------------- 운영 관리 --------------------------------

import UserManagement from "@/pages/Operation/UserManagement";
import LevelManagement from "@/pages/Operation/LevelManagement";
import CodeManagement from "@/pages/Operation/CodeManagement";
import PrintOCRManagement from "@/pages/Operation/PrintOCRManagement";
import PrintLabelManagement from "@/pages/Operation/PrintLabelManagement";
import EmailListManagement from "@/pages/Operation/EmailListManagement";
import BoardManagement from "@/pages/Operation/BoardManagement";
import KuaaDashboard from "@/pages/Operation/KuaaDashboard";

let OperationMenu = {
  path: "/Operation",
  component: DashboardLayout,
  beforeEnter: requireAuth(), // 로그인 여부에 따라서...
  name: "운영 관리",
  redirect: "/Operation/UserManagement",
  children: [
    {
      path: "UserManagement",
      name: "사용자 관리",
      components: { default: UserManagement }
    },
    {
      path: "LevelManagement",
      name: "권한 관리",
      components: { default: LevelManagement }
    },
    {
      path: "CodeManagement",
      name: "코드 관리",
      components: { default: CodeManagement }
    },
    {
      path: "PrintOCRManagement",
      name: "OCR 출력",
      components: { default: PrintOCRManagement }
    },
    {
      path: "PrintLabelManagement",
      name: "라벨 출력",
      components: { default: PrintLabelManagement }
    },
    {
      path: "EmailListManagement",
      name: "이메일 목록 관리",
      components: { default: EmailListManagement }
    },
    {
      path: "BoardManagement",
      name: "게시판",
      components: { default: BoardManagement }
    },
    {
      path: "KuaaDashboard",
      name: "대쉬보드",
      components: { default: KuaaDashboard }
    }
  ]
};

// ----------------------------------------------------------------------

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      components: { default: Buttons }
    },
    {
      path: "grid-system",
      name: "Grid System",
      components: { default: GridSystem }
    },
    {
      path: "panels",
      name: "Panels",
      components: { default: Panels }
    },
    {
      path: "sweet-alert",
      name: "Sweet Alert",
      components: { default: SweetAlert }
    },
    {
      path: "notifications",
      name: "Notifications",
      components: { default: Notifications }
    },
    {
      path: "notificationsTest",
      name: "NotificationsTest",
      components: { default: NotificationsTest }
    },
    {
      path: "icons",
      name: "Icons",
      components: { default: Icons }
    }
  ]
};

let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  name: "Forms",
  children: [
    {
      path: "regular",
      name: "Regular Forms",
      components: { default: RegularForms }
    },
    {
      path: "extended",
      name: "Extended Forms",
      components: { default: ExtendedForms }
    },
    {
      path: "validation",
      name: "Validation Forms",
      components: { default: ValidationForms }
    },
    {
      path: "wizard",
      name: "Wizard",
      components: { default: Wizard }
    }
  ]
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  redirect: "/table-list/regular",
  name: "Tables",
  children: [
    {
      path: "regular",
      name: "Regular Tables",
      components: { default: RegularTables }
    },
    {
      path: "extended",
      name: "Extended Tables",
      components: { default: ExtendedTables }
    },
    {
      path: "paginated",
      name: "Pagianted Tables",
      components: { default: PaginatedTables }
    }
  ]
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  name: "Maps",
  redirect: "/maps/google",
  children: [
    {
      path: "google",
      name: "Google Maps",
      components: { default: GoogleMaps }
    },
    {
      path: "full-screen",
      name: "Full Screen Map",
      meta: {
        hideContent: true,
        hideFooter: true,
        navbarAbsolute: true
      },
      components: { default: FullScreenMap }
    },
    {
      path: "vector-map",
      name: "Vector Map",
      components: { default: VectorMaps }
    }
  ]
};

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/pages/user",
  children: [
    {
      path: "user",
      name: "User Page",
      components: { default: User }
    },
    {
      path: "timeline",
      name: "Timeline Page",
      components: { default: TimeLine }
    },
    {
      path: "rtl",
      name: "وحة القيادة",
      meta: {
        rtlActive: true
      },
      components: { default: RtlSupport }
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing
    },
    {
      path: "/lock",
      name: "Lock",
      component: Lock
    },
    {
      path: "/InboundCall",
      name: "전화받기",
      component: InboundCall
    }
  ]
};

import Error404 from "@/pages/ErrorPage/Error404";

const routes = [
  {
    path: "/",
    name: "FirstAccess",
    redirect: "/Login"
  },
  authPages,
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  FriendshipMenu, //added by psk 20200619
  MembershipFeeMenu, //added by psk 20200623
  MembershipGroupMenu, //added by psk 20200623
  KuaaEventMenu, //added by psk 20200623
  CounselorMenu, //added by psk 20200623
  ScholarshipMenu, //added by psk 20200623
  OperationMenu, //added by psk 20200623
  {
    path: "/",
    component: DashboardLayout,
    beforeEnter: requireAuth(), // 로그인 여부에 따라서...
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard }
      },
      {
        path: "calendar",
        name: "Calendar",
        components: { default: Calendar }
      },
      {
        path: "charts",
        name: "Charts",
        components: { default: Charts }
      },
      {
        path: "widgets",
        name: "Widgets",
        components: { default: Widgets }
      }
    ]
  },
  {
    //path: '/:pathMatch(.*)*',
    path: '*',
    redirect: "/404"
  },
  {
    path: '/404',
    component: Error404
  }
];

export default routes;
